import React, { useEffect } from 'react';

import actions from '../../Actions';

export default function WaitReport({ reportData, closeForm }) {
  useEffect(() => {
    let timeoutId = null;
    const checkFunction = () => {
      actions.getReportStatus(reportData, (data) => {
        // closeForm();
        if (data.status === 'completed') {
          closeForm();
          window.open(`/reports/report_preview?report_content_id=${reportData.report_content_id}`, '_blank');
        } else {
          timeoutId = setTimeout(checkFunction, 2000);
        }
      });
    };

    timeoutId = setTimeout(checkFunction, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  return <div className="mt20">Please, wait while report generated ...</div>;
}
